import React from 'react';
import { HERO_IMAGE, HERO_IMAGE_ALT } from '../data/product';
import { VolumeCover } from './VolumeCover';

/** Title lines as they print on each cover. */
const COVERS: {
  number: number;
  lines: string[];
}[] = [{
  number: 1,
  lines: ['Set Up the Squad']
}, {
  number: 2,
  lines: ['Bat Without', 'the Queue']
}, {
  number: 3,
  lines: ['Bowl Line', 'and Length']
}, {
  number: 4,
  lines: ['Field Like', 'a Team']
}, {
  number: 5,
  lines: ['Play the Match', 'Before Match Day']
}, {
  number: 6,
  lines: ['Finish the', 'Season Strong']
}];

/**
 * Fan order, left to right. Volume 1 sits almost upright at the front;
 * the rest fan out behind it.
 */
const FAN: {
  vol: number;
  deg: number;
  z: number;
}[] = [{
  vol: 5,
  deg: -30,
  z: 1
}, {
  vol: 3,
  deg: -19,
  z: 2
}, {
  vol: 1,
  deg: -4,
  z: 6
}, {
  vol: 2,
  deg: 8,
  z: 5
}, {
  vol: 4,
  deg: 19,
  z: 3
}, {
  vol: 6,
  deg: 30,
  z: 1
}];
type ProductVisualProps = {
  className?: string;
  /** Show the gold "90 sessions" seal. */
  seal?: boolean;
  lazy?: boolean;
};

/**
 * The pack. Shows the uploaded mockup when HERO_IMAGE is set; otherwise draws
 * the six volumes in code, fanned like a hand of cards.
 */
export function ProductVisual({
  className = '',
  seal = true,
  lazy = false
}: ProductVisualProps) {
  if (HERO_IMAGE) {
    return <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} width={1792} height={1024} loading={lazy ? 'lazy' : undefined} className={`block h-auto w-full rounded-2xl border border-white/10 shadow-book sm:rounded-3xl ${className}`} data-id="element-281" data-mp="29axjlawlgfj0" />;
  }
  return <div className={`relative mx-auto aspect-[4/3] w-full ${className}`} role="img" aria-label={HERO_IMAGE_ALT} data-id="element-282" data-mp="2x0rydy0h4e5w">
      {/* soft pool of floodlight under the pack */}
      <span className="absolute inset-x-[8%] bottom-[2%] h-[22%] rounded-[50%] bg-black/45 blur-2xl" aria-hidden="true" data-id="element-283" data-mp="2rzucbaccezz4" />
      <div aria-hidden="true" data-id="element-284" data-mp="xopewnrunjs8">
        {FAN.map(f => {
        const cover = COVERS[f.vol - 1];
        return <VolumeCover key={f.vol} number={cover.number} lines={cover.lines} className="!absolute bottom-[5%] left-[32%] w-[36%]" style={{
          transform: `rotate(${f.deg}deg)`,
          transformOrigin: '50% 96%',
          zIndex: f.z,
          filter: f.vol === 1 ? undefined : `brightness(${0.62 + f.z * 0.06})`
        }} data-id="element-285" data-mp="2xrgtbvblp6u6" />;
      })}
      </div>

      {seal && <div className="absolute right-[2%] top-[4%] z-10 flex h-[20%] w-auto aspect-square rotate-[8deg] flex-col items-center justify-center rounded-full bg-willow text-center text-willow-ink shadow-lift ring-4 ring-willow/30" aria-hidden="true" data-id="element-286" data-mp="3lmt8xt39xlhe">
          <span className="font-display text-[clamp(18px,4.2vw,34px)] font-black leading-none" data-id="element-287" data-mp="3awl7tz8hl6j">90</span>
          <span className="mt-0.5 max-w-[80%] text-[clamp(7px,1.25vw,10px)] font-bold uppercase leading-tight tracking-wide" data-id="element-288" data-mp="8a9gn34680kq">
            ready-to-run sessions
          </span>
        </div>}
    </div>;
}